/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {CampaignSettings} from './CampaignSettings';
import {CampaignsSegments} from './CampaignsSegments';
import {CampaignsTemplates} from './CampaignsTemplates';

/**
 * The CampaignsBody model module.
 * @module model/CampaignsBody
 * @version 1.0.0
 */
export class CampaignsBody {
  /**
   * Constructs a new <code>CampaignsBody</code>.
   * @alias module:model/CampaignsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CampaignsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CampaignsBody} obj Optional instance to populate.
   * @return {module:model/CampaignsBody} The populated <code>CampaignsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CampaignsBody();
      if (data.hasOwnProperty('propertyId'))
        obj.propertyId = ApiClient.convertToType(data['propertyId'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('templates'))
        obj.templates = ApiClient.convertToType(data['templates'], [CampaignsTemplates]);
      if (data.hasOwnProperty('segments'))
        obj.segments = CampaignsSegments.constructFromObject(data['segments']);
      if (data.hasOwnProperty('espId'))
        obj.espId = ApiClient.convertToType(data['espId'], 'String');
      if (data.hasOwnProperty('settings'))
        obj.settings = CampaignSettings.constructFromObject(data['settings']);
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('updated'))
        obj.updated = ApiClient.convertToType(data['updated'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} propertyId
 */
CampaignsBody.prototype.propertyId = undefined;

/**
 * @member {String} title
 */
CampaignsBody.prototype.title = undefined;

/**
 * @member {String} description
 */
CampaignsBody.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
CampaignsBody.prototype.enabled = undefined;

/**
 * @member {Array.<module:model/CampaignsTemplates>} templates
 */
CampaignsBody.prototype.templates = undefined;

/**
 * @member {module:model/CampaignsSegments} segments
 */
CampaignsBody.prototype.segments = undefined;

/**
 * @member {String} espId
 */
CampaignsBody.prototype.espId = undefined;

/**
 * @member {module:model/CampaignSettings} settings
 */
CampaignsBody.prototype.settings = undefined;

/**
 * @member {String} created
 */
CampaignsBody.prototype.created = undefined;

/**
 * @member {String} updated
 */
CampaignsBody.prototype.updated = undefined;

